(() => {
  console.log("SkinLife JS Loaded");
  'use strict';

  if (window.SkinLifeIdentityPricingLoaded) return;
  window.SkinLifeIdentityPricingLoaded = true;

  const WRAPPER_SELECTOR = '[data-skinlife-id-verification]';

  function normalizeIdentityNumber(value) {
    return String(value || '')
      .replace(/[٠-٩]/g, (digit) =>
        String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit))
      )
      .replace(/[۰-۹]/g, (digit) =>
        String('۰۱۲۳۴۵۶۷۸۹'.indexOf(digit))
      )
      .replace(/\D/g, '')
      .slice(0, 10);
  }

  function getElements(wrapper) {

  const input = wrapper.querySelector(
    '.skinlife-id-verification__input'
  );

  const errorBox = wrapper.querySelector(
    '.skinlife-id-verification__error'
  );

  let form = wrapper.closest('form');

  if (!form) {
    form = document.querySelector('product-form form');
  }

  if (!form) {
    form = document.querySelector('form[action*="/cart/add"]');
  }

  return {
    input,
    errorBox,
    form
  };

}

  function showError(wrapper, input, errorBox, message) {
    input.setCustomValidity(message);
    input.setAttribute('aria-invalid', 'true');

    if (errorBox) {
      errorBox.textContent = message;
      errorBox.hidden = false;
    }
  }

  function clearError(input, errorBox) {
    input.setCustomValidity('');
    input.removeAttribute('aria-invalid');

    if (errorBox) {
      errorBox.textContent = '';
      errorBox.hidden = true;
    }
  }

  function getRequiredMessage(wrapper) {
    return (
      wrapper.dataset.requiredMessage ||
      'National ID or Iqama number is required.'
    );
  }

  function getInvalidMessage(wrapper) {
    return (
      wrapper.dataset.invalidMessage ||
      'Enter a valid 10-digit number starting with 1 or 2.'
    );
  }

  function selectCorrectVariant(wrapper, form, identityNumber) {
    const variantInput = form.querySelector(
      'input[name="id"].product-variant-id, input[name="id"]'
    );

    if (!variantInput) {
      console.error(
        'Skin Life: hidden variant input was not found.'
      );
      return false;
    }

    const selectedVariantId =
      identityNumber.charAt(0) === '1'
        ? wrapper.dataset.saudiVariant
        : wrapper.dataset.residentVariant;

    if (!selectedVariantId) {
      console.error(
        'Skin Life: Saudi or resident variant ID is missing.'
      );
      return false;
    }

    /*
      Ensure the field is submitted even if the first variant
      was previously unavailable.
    */
    variantInput.disabled = false;

    /*
      Replace the submitted variant immediately before
      Shopify creates the cart request.
    */
    variantInput.value = String(selectedVariantId);

    return true;
  }

  function validateAndPrepare(wrapper) {
    const { input, errorBox, form } = getElements(wrapper);

    if (!input || !form) {
      console.error(
        'Skin Life: identity input must be inside the product form.'
      );
      return false;
    }

    const identityNumber = normalizeIdentityNumber(input.value);
    input.value = identityNumber;

    if (!identityNumber) {
      showError(
        wrapper,
        input,
        errorBox,
        getRequiredMessage(wrapper)
      );
      return false;
    }

    if (!/^[12]\d{9}$/.test(identityNumber)) {
      showError(
        wrapper,
        input,
        errorBox,
        getInvalidMessage(wrapper)
      );
      return false;
    }

    if (!selectCorrectVariant(wrapper, form, identityNumber)) {
      showError(
        wrapper,
        input,
        errorBox,
        getInvalidMessage(wrapper)
      );
      return false;
    }

    clearError(input, errorBox);
    return true;
  }

  function initializeWrapper(wrapper) {
    if (wrapper.dataset.skinlifeInitialized === 'true') {
      return;
    }

    const { input, errorBox, form } = getElements(wrapper);

    if (!input || !form) {
      console.error(
        'Skin Life: verification field or product form not found.'
      );
      return;
    }

    wrapper.dataset.skinlifeInitialized = 'true';

    input.addEventListener('input', () => {
      input.value = normalizeIdentityNumber(input.value);
      clearError(input, errorBox);
    });

    /*
      Capture phase runs before Sense processes its AJAX
      add-to-cart submission.
    */
    form.addEventListener(
      'submit',
      (event) => {
        if (validateAndPrepare(wrapper)) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        input.reportValidity();
        input.focus();
        input.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      },
      true
    );
  }

  function initializeAll() {
    document
      .querySelectorAll(WRAPPER_SELECTOR)
      .forEach(initializeWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAll
    );
  } else {
    initializeAll();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeAll
  );
})();